export function normalizeRGB(rgb) {
  const mean=[0,0,0];
  rgb.forEach(v=>{
    mean[0]+=v[0]; mean[1]+=v[1]; mean[2]+=v[2];
  });
  return rgb.map(v=>[
    v[0]/mean[0], v[1]/mean[1], v[2]/mean[2]
  ]);
}

let prev=null;
export function motionReject(rgb) {
  if(!prev){ prev=rgb; return false; }
  const d=Math.abs(rgb[0]-prev[0])+Math.abs(rgb[1]-prev[1])+Math.abs(rgb[2]-prev[2]);
  prev=rgb;
  return d>25;
}

export function bandpass(sig){
  return sig.map((v,i,a)=>i<2?v:a[i]-0.95*a[i-1]+0.9*a[i-2]);
}

export function sqi(sig){
  const p=sig.reduce((s,v)=>s+v*v,0);
  return p/sig.length;
}
